// extracted by mini-css-extract-plugin
module.exports = {"Container":"Title_Container__3MLwF","Title":"Title_Title__1d8Qb"};